"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HubPool__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "contract LpTokenFactoryInterface",
                name: "_lpTokenFactory",
                type: "address",
            },
            {
                internalType: "contract FinderInterface",
                name: "_finder",
                type: "address",
            },
            {
                internalType: "contract WETH9Interface",
                name: "_weth",
                type: "address",
            },
            {
                internalType: "address",
                name: "_timer",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "newBondToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newBondAmount",
                type: "uint256",
            },
        ],
        name: "BondSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "l2ChainId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "adapter",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "spokePool",
                type: "address",
            },
        ],
        name: "CrossChainContractsSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "poolRebalanceRoot",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "relayerRefundRoot",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "slowRelayRoot",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "proposer",
                type: "address",
            },
        ],
        name: "EmergencyRootBundleDeleted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "newIdentifier",
                type: "bytes32",
            },
        ],
        name: "IdentifierSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "l1Token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "lpToken",
                type: "address",
            },
        ],
        name: "L1TokenEnabledForLiquidityProvision",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "l1Token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "lpToken",
                type: "address",
            },
        ],
        name: "L2TokenDisabledForLiquidityProvision",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "l1Token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "lpTokensMinted",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "liquidityProvider",
                type: "address",
            },
        ],
        name: "LiquidityAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "l1Token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "lpTokensBurnt",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "liquidityProvider",
                type: "address",
            },
        ],
        name: "LiquidityRemoved",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "newLiveness",
                type: "uint256",
            },
        ],
        name: "LivenessSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bool",
                name: "isPaused",
                type: "bool",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint32",
                name: "challengePeriodEndTimestamp",
                type: "uint32",
            },
            {
                indexed: false,
                internalType: "uint8",
                name: "poolRebalanceLeafCount",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "bundleEvaluationBlockNumbers",
                type: "uint256[]",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "poolRebalanceRoot",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "relayerRefundRoot",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "slowRelayRoot",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "proposer",
                type: "address",
            },
        ],
        name: "ProposeRootBundle",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "newProtocolFeeCaptureAddress",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "newProtocolFeeCapturePct",
                type: "uint256",
            },
        ],
        name: "ProtocolFeeCaptureSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "l1Token",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "accumulatedFees",
                type: "uint256",
            },
        ],
        name: "ProtocolFeesCapturedClaimed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "disputer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "requestTime",
                type: "uint256",
            },
        ],
        name: "RootBundleCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "disputer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "requestTime",
                type: "uint256",
            },
        ],
        name: "RootBundleDisputed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "groupIndex",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "leafId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "chainId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address[]",
                name: "l1Tokens",
                type: "address[]",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "bundleLpFees",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "int256[]",
                name: "netSendAmounts",
                type: "int256[]",
            },
            {
                indexed: false,
                internalType: "int256[]",
                name: "runningBalances",
                type: "int256[]",
            },
            {
                indexed: true,
                internalType: "address",
                name: "caller",
                type: "address",
            },
        ],
        name: "RootBundleExecuted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "originChainId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "destinationChainId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "originToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "depositsEnabled",
                type: "bool",
            },
        ],
        name: "SetEnableDepositRoute",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "destinationChainId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "l1Token",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "destinationToken",
                type: "address",
            },
        ],
        name: "SetPoolRebalanceRoute",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "chainId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "message",
                type: "bytes",
            },
        ],
        name: "SpokePoolAdminFunctionTriggered",
        type: "event",
    },
    {
        stateMutability: "payable",
        type: "fallback",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "l1Token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "l1TokenAmount",
                type: "uint256",
            },
        ],
        name: "addLiquidity",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "bondAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "bondToken",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "l1Token",
                type: "address",
            },
        ],
        name: "claimProtocolFeesCaptured",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "crossChainContracts",
        outputs: [
            {
                internalType: "address",
                name: "adapter",
                type: "address",
            },
            {
                internalType: "address",
                name: "spokePool",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "l1Token",
                type: "address",
            },
        ],
        name: "disableL1TokenForLiquidityProvision",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "disputeRootBundle",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "emergencyDeleteProposal",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "l1Token",
                type: "address",
            },
        ],
        name: "enableL1TokenForLiquidityProvision",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "l1Token",
                type: "address",
            },
        ],
        name: "exchangeRateCurrent",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "chainId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "groupIndex",
                type: "uint256",
            },
            {
                internalType: "uint256[]",
                name: "bundleLpFees",
                type: "uint256[]",
            },
            {
                internalType: "int256[]",
                name: "netSendAmounts",
                type: "int256[]",
            },
            {
                internalType: "int256[]",
                name: "runningBalances",
                type: "int256[]",
            },
            {
                internalType: "uint8",
                name: "leafId",
                type: "uint8",
            },
            {
                internalType: "address[]",
                name: "l1Tokens",
                type: "address[]",
            },
            {
                internalType: "bytes32[]",
                name: "proof",
                type: "bytes32[]",
            },
        ],
        name: "executeRootBundle",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "finder",
        outputs: [
            {
                internalType: "contract FinderInterface",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getCurrentTime",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "l1Token",
                type: "address",
            },
            {
                internalType: "int256",
                name: "haircutAmount",
                type: "int256",
            },
        ],
        name: "haircutReserves",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "identifier",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "l1Token",
                type: "address",
            },
        ],
        name: "liquidityUtilizationCurrent",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "l1Token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "relayedAmount",
                type: "uint256",
            },
        ],
        name: "liquidityUtilizationPostRelay",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "liveness",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "loadEthForL2Calls",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "lpFeeRatePerSecond",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lpTokenFactory",
        outputs: [
            {
                internalType: "contract LpTokenFactoryInterface",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "data",
                type: "bytes[]",
            },
        ],
        name: "multicall",
        outputs: [
            {
                internalType: "bytes[]",
                name: "results",
                type: "bytes[]",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "destinationChainId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "l1Token",
                type: "address",
            },
        ],
        name: "poolRebalanceRoute",
        outputs: [
            {
                internalType: "address",
                name: "destinationToken",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "pooledTokens",
        outputs: [
            {
                internalType: "address",
                name: "lpToken",
                type: "address",
            },
            {
                internalType: "bool",
                name: "isEnabled",
                type: "bool",
            },
            {
                internalType: "uint32",
                name: "lastLpFeeUpdate",
                type: "uint32",
            },
            {
                internalType: "int256",
                name: "utilizedReserves",
                type: "int256",
            },
            {
                internalType: "uint256",
                name: "liquidReserves",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "undistributedLpFees",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256[]",
                name: "bundleEvaluationBlockNumbers",
                type: "uint256[]",
            },
            {
                internalType: "uint8",
                name: "poolRebalanceLeafCount",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "poolRebalanceRoot",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "relayerRefundRoot",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "slowRelayRoot",
                type: "bytes32",
            },
        ],
        name: "proposeRootBundle",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "protocolFeeCaptureAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "protocolFeeCapturePct",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "chainId",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "functionData",
                type: "bytes",
            },
        ],
        name: "relaySpokePoolAdminFunction",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "l1Token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "lpTokenAmount",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "sendEth",
                type: "bool",
            },
        ],
        name: "removeLiquidity",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "rootBundleProposal",
        outputs: [
            {
                internalType: "bytes32",
                name: "poolRebalanceRoot",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "relayerRefundRoot",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "slowRelayRoot",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "claimedBitMap",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                internalType: "uint8",
                name: "unclaimedPoolRebalanceLeafCount",
                type: "uint8",
            },
            {
                internalType: "uint32",
                name: "challengePeriodEndTimestamp",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IERC20",
                name: "newBondToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "newBondAmount",
                type: "uint256",
            },
        ],
        name: "setBond",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "l2ChainId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "adapter",
                type: "address",
            },
            {
                internalType: "address",
                name: "spokePool",
                type: "address",
            },
        ],
        name: "setCrossChainContracts",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "time",
                type: "uint256",
            },
        ],
        name: "setCurrentTime",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "originChainId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "destinationChainId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "originToken",
                type: "address",
            },
            {
                internalType: "bool",
                name: "depositsEnabled",
                type: "bool",
            },
        ],
        name: "setDepositRoute",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "newIdentifier",
                type: "bytes32",
            },
        ],
        name: "setIdentifier",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "newLiveness",
                type: "uint32",
            },
        ],
        name: "setLiveness",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bool",
                name: "pause",
                type: "bool",
            },
        ],
        name: "setPaused",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "destinationChainId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "l1Token",
                type: "address",
            },
            {
                internalType: "address",
                name: "destinationToken",
                type: "address",
            },
        ],
        name: "setPoolRebalanceRoute",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newProtocolFeeCaptureAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "newProtocolFeeCapturePct",
                type: "uint256",
            },
        ],
        name: "setProtocolFeeCapture",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "l1Token",
                type: "address",
            },
        ],
        name: "sync",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "timerAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "unclaimedAccumulatedProtocolFees",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "weth",
        outputs: [
            {
                internalType: "contract WETH9Interface",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "0x60e034620001a457601f6200447c38819003918201601f19168301916001600160401b03831184841017620001a957808492608094604052833981010312620001a45780516001600160a01b03918282168203620001a45760208101518381168103620001a4576040820151918483168303620001a45760600151848116809103620001a457600080546001600160a81b031916909117600160a01b178155600180546001600160a01b031981163390811792839055604051979296939092909116907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e09080a3600c805463ffffffff60a01b191660e160a51b1790556820a1a927a9a996ab1960b91b600d5565015d3ef79800600e5560a05260c052608052600b8054610100600160a81b03191660089290921b610100600160a81b03169190911790556142bc9081620001c082396080518181816107d501528181610fe80152818161111801526140da015260a0518181816115ea0152611e5d015260c05181818161050201528181610ea301528181611f6d0152818161377d015261382b0152f35b600080fd5b634e487b7160e01b600052604160045260246000fdfe60806040526004361015610026575b361561001e5761001c6140c9565b005b61001c6140c9565b60003560e01c8062660b5314610314578062c992061461030f578063084d05131461030a57806309474ae2146103055780630c501af9146103005780630ee28a88146102fb57806310b99527146102f657806311cfc159146102f157806316c38b3c146102ec5780631c39c38d146102e757806322395aaa146102e257806322f8e566146102dd578063240f475f146102d857806326205d80146102d357806329cb924d146102ce5780632d0f6f84146102c95780632d32d557146102c457806333dc09ca146102bf5780633fc8cef3146102ba5780634144fd61146102b55780634f7473ff146102b057806356688700146102ab57806356864f38146102a65780635c975abb146102a1578063625997c01461029c57806369b62502146102975780636ad0690a14610292578063715018a61461028d57806376ec08dd146102885780637998a1c41461028357806380c09a821461027e57806380f323a7146102795780638bda0c00146102745780638da5cb5b1461026f578063a16fd6e91461026a578063a584119414610265578063ac9650d814610260578063b60c2d7d1461025b578063b9a3c84c14610256578063c28f439214610251578063cd9499951461024c578063dd70e5e814610247578063e0f339e314610242578063e40064d71461023d578063e460e35c14610238578063f0056a7d146102335763f2fde38b0361000e5761231e565b6122a0565b6121b8565b61217b565b61213f565b6120ca565b611fc5565b611f9c565b611f57565b611d36565b611c43565b611b4a565b611b0e565b611ae5565b611916565b6118f8565b61184e565b611619565b6115d4565b611576565b61154f565b611541565b6113e1565b6113be565b6112e9565b611098565b61107a565b611017565b610fd2565b610e0b565b610dc2565b610d22565b610d07565b610c8d565b610c60565b610bfa565b610b92565b610b69565b610ae3565b610ac5565b610a17565b610773565b6106cf565b610683565b610627565b610482565b61032f565b6001600160a01b0381160361032a57565b600080fd5b3461032a57604036600319011261032a5760043561034c81610319565b6024356103576123e6565b61035f614139565b6000805460ff60a01b1916815591670de0b6b3a7640000821161043d576001600160a01b0381169081156103f857600b8054610100600160a81b03191660089290921b610100600160a81b03169190911790556103bb82600f55565b7fc1993b89fd79a19ece7beb067ddc8534ca26d29c0ff94ea2f53b4a508d1eedc98380a36000805460ff60a01b1916600160a01b17905580f35b80f35b60405162461bcd60e51b815260206004820152601d60248201527f4261642070726f746f636f6c46656543617074757265416464726573730000006044820152606490fd5b60405162461bcd60e51b815260206004820152601960248201527f4261642070726f746f636f6c46656543617074757265506374000000000000006044820152606490fd5b3461032a5760208060031936011261032a57600435906104a06123e6565b6104b260ff60065460a01c16156128a3565b6104ba614139565b6000805460ff60a01b191681556040516302abf57960e61b8152721259195b9d1a599a595c95da1a5d195b1a5cdd606a1b600482015290926001600160a01b039183816024817f000000000000000000000000000000000000000000000000000000000000000087165afa9283156105f357849186946105f8575b506040516390978d1b60e01b8152600481018490529384916024918391165afa9283156105f3577ff45367c278fcceff23d601ce4bdd191e5bd61687ff9f29dc7276a08fe54c0c5d936105ad936105949287926105c6575b505061299c565b61059d81600d55565b6040519081529081906020820190565b0390a16000805460ff60a01b1916600160a01b17905580f35b6105e59250803d106105ec575b6105dd81836116d1565b8101906126e7565b388061058d565b503d6105d3565b61261b565b610619919450823d8411610620575b61061181836116d1565b81019061293b565b9238610535565b503d610607565b3461032a57604036600319011261032a57602061066760043561064981610319565b610651614139565b6000805460ff60a01b1916905560243590613e23565b6000805460ff60a01b1916600160a01b1790555b604051908152f35b3461032a57602036600319011261032a57600435600090815260096020908152604091829020805460019091015483516001600160a01b039283168152911691810191909152f35b0390f35b3461032a57602036600319011261032a576004356106ec81610319565b6106f46123e6565b6106fc614139565b6000805460ff60a01b1990811682556001600160a01b03928316808352600760209081526040808520805494851690558051928352929094169381019390935290917fac111b3b527b307393c94d98f26140effb71411054466818be97912d2d65f77691819081016105ad565b8015150361032a57565b3461032a57606036600319011261032a5760043561079081610319565b602435906044356107a081610769565b6107a8614139565b6000805490939060ff60a01b191684556107c760ff600b541615612a01565b6001600160a01b03838116927f0000000000000000000000000000000000000000000000000000000000000000909116919083831480156109e3575b61080c90612b50565b61082f61082161081b87613aec565b84612adb565b670de0b6b3a7640000900490565b9461086e6108626108626108558460018060a01b03166000526007602052604060002090565b546001600160a01b031690565b6001600160a01b031690565b60405163079cc67960e41b8152336004820152602481018590529190602090839060449082908c905af19081156105f3576002926108c6926109c5575b506001600160a01b0316600090815260076020526040902090565b016108d2868254612b8c565b90551561098e57813b1561098a57604051632e1a7d4d60e01b8152600481018590529185908390602490829084905af19081156105f3577fcda1185f28599e6bd14ab8a68b3c30a11e1dce4256b5e67e94dd3fd846a6c5899261095892610971575b5061093f8533612b99565b6040805195865260208601919091523394918291820190565b0390a36000805460ff60a01b1916600160a01b17905580f35b8061097e6109849261164d565b80610aba565b38610934565b8480fd5b7fcda1185f28599e6bd14ab8a68b3c30a11e1dce4256b5e67e94dd3fd846a6c5899150610958906109c085338661269f565b61093f565b6109dc9060203d81116105ec576105dd81836116d1565b50386108ab565b508015610803565b606090600319011261032a5760043590602435610a0781610319565b90604435610a1481610319565b90565b3461032a57610a25366109eb565b91610a2e6123e6565b610a36614139565b6000805460ff60a01b1916815592610a4e8284613fe0565b845260086020526040842080546001600160a01b0319166001600160a01b0383161790556001600160a01b039081169216907f234e7af08f77827792cc909447f27d2e6a3e2d839b04e26b50b71704a131c8a88480a46000805460ff60a01b1916600160a01b17905580f35b600091031261032a57565b3461032a57600036600319011261032a576020600e54604051908152f35b3461032a57602036600319011261032a57600435610b0081610769565b610b086123e6565b610b10614139565b60009060ff60a01b198254168255151560ff19600b541660ff821617600b557f0e2fb031ee032dc02d8011dc50b816eb450cf856abd8261680dac74f72165bd28280a26000805460ff60a01b1916600160a01b17905580f35b3461032a57600036600319011261032a576000546040516001600160a01b039091168152602090f35b3461032a57600080600319360112610bf757610bac614139565b805460ff60a01b19168155610bbf613282565b600c54610be1906001600160a01b0390811690610bda613740565b1690613585565b6000805460ff60a01b1916600160a01b17905580f35b80fd5b3461032a5760006020366003190112610bf757805481906001600160a01b03168015610c5d57803b15610c5d57819060246040518094819363117c72b360e11b835260043560048401525af180156105f357610c54575080f35b6103f59061164d565b50fd5b3461032a57600036600319011261032a57600b5460405160089190911c6001600160a01b03168152602090f35b3461032a57604036600319011261032a57600435610caa81610319565b610cb26123e6565b610cba614139565b6000805460ff60a01b191681556001600160a01b0390911681526007602052604081206001018054610cef90602435906129e8565b90556000805460ff60a01b1916600160a01b17905580f35b3461032a57600036600319011261032a57602061067b612636565b3461032a57602036600319011261032a57600435610d3f81610319565b610d47614139565b6000805460ff60a01b191681556001600160a01b03918216808252600a60205260408220805490839055600b5492939092610d8891849160081c168361269f565b7f74740239d7d696c84422b720e125e1f47c4138c66d1f4d2a48e99f4197cdb79c8380a36000805460ff60a01b1916600160a01b17905580f35b3461032a57604036600319011261032a57610deb602435610de281610319565b60043590613fe0565b6000526008602052602060018060a01b0360406000205416604051908152f35b3461032a57604036600319011261032a57600435610e2881610319565b602435610e336123e6565b610e4560ff60065460a01c16156128a3565b610e4d614139565b6000805460ff60a01b1916815591610e668215156128ef565b6040516302abf57960e61b81527210dbdb1b185d195c985b15da1a5d195b1a5cdd606a1b60048201526001600160a01b03926020919082826024817f000000000000000000000000000000000000000000000000000000000000000089165afa9182156105f3578692610fb3575b50604051631d1d5b3960e11b81528585166001600160a01b0381166004830152959092849184916024918391165afa9182156105f3577fbfa9a96010167e98ce8c004f718932cbbfd33a58d681c752e693be7d457a1b3b94610f49610f7494610f6693610f7d978b92610f96575b5050612950565b60018060a01b03166001600160601b0360a01b600c541617600c55565b610f6e6137fd565b9061298f565b61059d81601055565b0390a26000805460ff60a01b1916600160a01b17905580f35b610fac9250803d106105ec576105dd81836116d1565b3880610f42565b610fcb919250833d85116106205761061181836116d1565b9038610ed4565b3461032a57600036600319011261032a576040517f00000000000000000000000000000000000000000000000000000000000000006001600160a01b03168152602090f35b3461032a57600036600319011261032a5760e060025463ffffffff600354600454600554906006549260405195865260208601526040850152606084015260018060a01b038116608084015260ff8160a01c1660a084015260a81c1660c0820152f35b3461032a57600036600319011261032a576020600f54604051908152f35b604036600319011261032a576004356110b081610319565b6024356110bb614139565b6000805490929060ff60a01b191683556110da60ff600b541615612a01565b6001600160a01b038116600090815260076020526040902061110990611104905460a01c60ff1690565b612a42565b6001600160a01b0381811691907f000000000000000000000000000000000000000000000000000000000000000016821480806112e0575b80156112d8575b61115190612a82565b6111bf61086261086261085561117861116989612abe565b61117288613aec565b90612aee565b9560026111978260018060a01b03166000526007602052604060002090565b016111a38a825461298f565b90556001600160a01b0316600090815260076020526040902090565b6040516340c10f1960e01b81523360048201526024810184905290602090829060449082908a905af180156105f3576112ba575b50806112b1575b1561128057813b1561127c57604051630d0e30db60e41b815290848260048134875af19081156105f3577f3c69701a61c79a92ef9692903aaa0068bce8771361ecb09547391e4fb4df85379261095892611269575b506040805195865260208601919091523394918291820190565b8061097e6112769261164d565b3861124f565b8380fd5b6109587f3c69701a61c79a92ef9692903aaa0068bce8771361ecb09547391e4fb4df8537916109c085303387612b0e565b503415156111fa565b6112d19060203d81116105ec576105dd81836116d1565b50386111f3565b503415611148565b50833414611141565b3461032a57608036600319011261032a5760443560243560043561130c83610319565b7fb7d00a563842efb2c121a0eb02b7bb7ba1a34625bbc3d65057f1f0dbec0ec2a160206064359461133c86610769565b611344614139565b60005460ff60a01b19166000556113596123e6565b60405163272751c760e01b838201526001600160a01b03909116602482018190526044820186905295151560648083018290528252906113a29061139c816116b6565b85613f74565b604051908152a46000805460ff60a01b1916600160a01b179055005b3461032a57600036600319011261032a57602060ff600b54166040519015158152f35b3461032a57600080600319360112610bf7576113fb6123e6565b611403614139565b805460ff60a01b1916815560405161141a81611665565b600254815260035460208201908152600454906040830191825260055460608401527f993cba33f9b140c9ce20ba10d7eda92128d5beb6df856f064916108a11647a736114ff6006546114ed608087019660ff6114d460018060a01b03948581168b526114af63ffffffff60a086019261149c868260a01c16859060ff169052565b60a81c1660c086019063ffffffff169052565b6114cd60006002556000600355600060045560006005556000600655565b5160ff1690565b16611518575b519451955196516001600160a01b031690565b60405196875216949081906020820190565b0390a46000805460ff60a01b1916600160a01b17905580f35b600c5461153c906001600160a01b031689516001600160a01b03166010549161269f565b6114da565b600036600319011261032a57005b3461032a57600036600319011261032a57602063ffffffff600c5460a01c16604051908152f35b3461032a57600080600319360112610bf7576115906123e6565b600180546001600160a01b0319811690915581906001600160a01b03167f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e08280a380f35b3461032a57600036600319011261032a576040517f00000000000000000000000000000000000000000000000000000000000000006001600160a01b03168152602090f35b3461032a57600036600319011261032a576020600d54604051908152f35b634e487b7160e01b600052604160045260246000fd5b6001600160401b03811161166057604052565b611637565b60e081019081106001600160401b0382111761166057604052565b604081019081106001600160401b0382111761166057604052565b60c081019081106001600160401b0382111761166057604052565b60a081019081106001600160401b0382111761166057604052565b90601f801991011681019081106001600160401b0382111761166057604052565b604051906116ff82611665565b565b6040519061016082018281106001600160401b0382111761166057604052565b6001600160401b0381116116605760051b60200190565b81601f8201121561032a5780359161174f83611721565b9261175d60405194856116d1565b808452602092838086019260051b82010192831161032a578301905b828210611787575050505090565b81358152908301908301611779565b60a4359060ff8216820361032a57565b6024359060ff8216820361032a57565b81601f8201121561032a578035916117cd83611721565b926117db60405194856116d1565b808452602092838086019260051b82010192831161032a578301905b828210611805575050505090565b838091833561181381610319565b8152019101906117f7565b9181601f8401121561032a578235916001600160401b03831161032a576020808501948460051b01011161032a57565b3461032a5761010036600319011261032a576001600160401b0360443581811161032a5761188160049136908301611738565b9060643583811161032a576118999036908301611738565b60843584811161032a576118b09036908401611738565b6118b8611796565b9060c43586811161032a576118d090369086016117b6565b9260e43596871161032a576118eb61001c973690870161181e565b9690956024359035612cd2565b3461032a57600036600319011261032a576020601054604051908152f35b3461032a5760a036600319011261032a576004356001600160401b03811161032a5761194690369060040161181e565b9061194f6117a6565b604435906064359260843591611963614139565b60005460ff60a01b191660005561198260ff60065460a01c16156128a3565b61199160ff600b541615612a01565b60ff811615611aa157611a897f3185fa6fac8e91dc65e7424a8081c73353151d2715bddb71db0982c1fe4c0fd4936119e86119d66119cd612636565b63ffffffff1690565b600c5460a01c63ffffffff1690612c74565b97611a0760006002556000600355600060045560006005556000600655565b6006805460ff60a01b60a087901b1664ffffffffff60a01b1990911663ffffffff60a81b60a88d901b16171790556002879055611a4388600355565b611a4c82600455565b600680546001600160a01b03191633179055600c54611a7b906001600160a01b03166010549030903390612b0e565b604051948594339a86612c8c565b0390a46000805460ff60a01b1916600160a01b179055005b606460405162461bcd60e51b815260206004820152602060248201527f42756e646c65206d7573742068617665206174206c656173742031206c6561666044820152fd5b3461032a57600036600319011261032a576001546040516001600160a01b039091168152602090f35b3461032a57602036600319011261032a576020610667600435611b3081610319565b611b38614139565b6000805460ff60a01b19169055613d64565b3461032a57602036600319011261032a57611b84600435611b6a81610319565b611b72614139565b6000805460ff60a01b19169055613c47565b6000805460ff60a01b1916600160a01b179055005b60005b838110611bac5750506000910152565b8181015183820152602001611b9c565b90602091611bd581518092818552858086019101611b99565b601f01601f1916010190565b602080820190808352835180925260408301928160408460051b8301019501936000915b848310611c155750505050505090565b9091929394958480611c33600193603f198682030187528a51611bbc565b9801930193019194939290611c05565b602036600319011261032a57600480356001600160401b03811161032a57611c6e903690830161181e565b90611c79341561243e565b611c828261248a565b9160005b818110611c9b57604051806106cb8682611be1565b600080611ca9838587612514565b60409391611cbb85518093819361255a565b0390305af490611cc9612568565b91829015611cf857505090611cf391611ce28287612607565b52611ced8186612607565b506124ea565b611c86565b826044899394511061032a57611d329183611d1d920160248091518301019101612598565b925162461bcd60e51b815292839283016125f6565b0390fd5b3461032a57602036600319011261032a57600435611d5381610319565b611d5b6123e6565b611d63614139565b6000805460ff60a01b191681556001600160a01b038083168252600760205260408220919290918290611d9590610855565b1615611e32575b6001600160a01b03811660009081526007602052604090207f04e291c80180d65a57b5bf1bed775777ec0d6f283ef34bcf130712714d8bb7f79250611dee90805460ff60a01b1916600160a01b179055565b6001600160a01b0381166000908152600760205260409020611e0f90610855565b604080516001600160a01b039384168152929091166020830152819081016105ad565b604051637e178db760e11b81526001600160a01b0382166004820152916020908390602490829087907f0000000000000000000000000000000000000000000000000000000000000000165af19182156105f3577f04e291c80180d65a57b5bf1bed775777ec0d6f283ef34bcf130712714d8bb7f792611eeb918591611f39575b506001600160a01b038316600090815260076020526040902080546001600160a01b0319166001600160a01b03909216919091179055565b611f34611ef96119cd612636565b6001600160a01b0383166000908152600760205260409020805463ffffffff60a81b191660a89290921b63ffffffff60a81b16919091179055565b611d9c565b611f51915060203d81116106205761061181836116d1565b38611eb3565b3461032a57600036600319011261032a576040517f00000000000000000000000000000000000000000000000000000000000000006001600160a01b03168152602090f35b3461032a57600036600319011261032a57600c546040516001600160a01b039091168152602090f35b3461032a57602036600319011261032a5760043563ffffffff811680820361032a5761025890611ff36123e6565b611ffb614139565b60005460ff60a01b1916600055111561207557600c805463ffffffff60a01b191660a083901b63ffffffff60a01b1617905560405163ffffffff90911681527f04dd1d84d387f404568a7954b5e398518bdd716e1a8f4a790be9a1a225ad934790602090a16000805460ff60a01b1916600160a01b179055005b60405162461bcd60e51b8152602060048201526012602482015271131a5d995b995cdcc81d1bdbc81cda1bdc9d60721b6044820152606490fd5b6001600160401b03811161166057601f01601f191660200190565b3461032a57604036600319011261032a576024356001600160401b03811161032a573660238201121561032a578060040135612105816120af565b9061211360405192836116d1565b808252366024828501011161032a57602081600092602461001c96018386013783010152600435612867565b3461032a57602036600319011261032a57602061066760043561216181610319565b612169614139565b6000805460ff60a01b19169055613aec565b3461032a57602036600319011261032a5760043561219881610319565b60018060a01b0316600052600a6020526020604060002054604051908152f35b3461032a5760607f36050d958750e6ac3aa674ac7bbe8d0ae6a2f7d4b808e8c2c42c1f22fc9fc4bb6121e9366109eb565b6121f5949291946123e6565b6121fd614139565b60009460ff60a01b19865416865561227960405161221a81611680565b6001600160a01b039283168082529383166020808301828152878b52600990915260408a20925183546001600160a01b031916908616178355909493600191511691019060018060a01b03166001600160601b0360a01b825416179055565b60405192835260208301526040820152a16000805460ff60a01b1916600160a01b17905580f35b3461032a57602036600319011261032a5760c06004356122bf81610319565b60018060a01b0380911660005260076020526040600020805490600181015463ffffffff6003600284015493015493604051958116865260ff8160a01c161515602087015260a81c1660408501526060840152608083015260a0820152f35b3461032a57602036600319011261032a5760043561233b81610319565b6123436123e6565b6001600160a01b0390811690811561239257600154826001600160601b0360a01b821617600155167f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e0600080a3005b60405162461bcd60e51b815260206004820152602660248201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160448201526564647265737360d01b6064820152608490fd5b6001546001600160a01b031633036123fa57565b606460405162461bcd60e51b815260206004820152602060248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e65726044820152fd5b1561244557565b60405162461bcd60e51b815260206004820152601b60248201527f4f6e6c79206d756c746963616c6c207769746820302076616c756500000000006044820152606490fd5b9061249482611721565b6124a160405191826116d1565b82815280926124b2601f1991611721565b019060005b8281106124c357505050565b8060606020809385010152016124b7565b634e487b7160e01b600052601160045260246000fd5b60001981146124f95760010190565b6124d4565b634e487b7160e01b600052603260045260246000fd5b91908110156125555760051b81013590601e198136030182121561032a5701908135916001600160401b03831161032a57602001823603811361032a579190565b6124fe565b908092918237016000815290565b3d15612593573d90612579826120af565b9161258760405193846116d1565b82523d6000602084013e565b606090565b60208183031261032a578051906001600160401b03821161032a570181601f8201121561032a5780516125ca816120af565b926125d860405194856116d1565b8184526020828401011161032a57610a149160208085019101611b99565b906020610a14928181520190611bbc565b80518210156125555760209160051b010190565b6040513d6000823e3d90fd5b9081602091031261032a575190565b6000546001600160a01b0316801561269a576020600491604051928380926329cb924d60e01b82525afa9081156105f357600091612672575090565b610a14915060203d8111612693575b61268b81836116d1565b810190612627565b503d612681565b504290565b60405163a9059cbb60e01b60208201526001600160a01b03909216602483015260448201929092526116ff916126e282606481015b03601f1981018452836116d1565b6126fc565b9081602091031261032a5751610a1481610769565b60405161275a916001600160a01b031661271582611680565b6000806020958685527f5361666545524332303a206c6f772d6c6576656c2063616c6c206661696c656487860152868151910182855af1612754612568565b916127d6565b8051908161276757505050565b82806127779383010191016126e7565b1561277f5750565b6084906040519062461bcd60e51b82526004820152602a60248201527f5361666545524332303a204552433230206f7065726174696f6e20646964206e6044820152691bdd081cdd58d8d9595960b21b6064820152fd5b9192901561283857508151156127ea575090565b3b156127f35790565b60405162461bcd60e51b815260206004820152601d60248201527f416464726573733a2063616c6c20746f206e6f6e2d636f6e74726163740000006044820152606490fd5b82519091501561284b5750805190602001fd5b60405162461bcd60e51b8152908190611d3290600483016125f6565b9061288e916128746123e6565b61287c614139565b6000805460ff60a01b19169055613f74565b6000805460ff60a01b1916600160a01b179055565b156128aa57565b60405162461bcd60e51b815260206004820152601d60248201527f50726f706f73616c2068617320756e636c61696d6564206c65617665730000006044820152606490fd5b156128f657565b60405162461bcd60e51b815260206004820152601760248201527f626f6e6420657175616c20746f2066696e616c206665650000000000000000006044820152606490fd5b9081602091031261032a5751610a1481610319565b1561295757565b60405162461bcd60e51b815260206004820152601060248201526f139bdd081bdb881dda1a5d195b1a5cdd60821b6044820152606490fd5b919082018092116124f957565b156129a357565b60405162461bcd60e51b815260206004820152601860248201527f4964656e746966696572206e6f7420737570706f7274656400000000000000006044820152606490fd5b818103929160001380158285131691841216176124f957565b15612a0857565b60405162461bcd60e51b815260206004820152601260248201527110dbdb9d1c9858dd081a5cc81c185d5cd95960721b6044820152606490fd5b15612a4957565b60405162461bcd60e51b8152602060048201526011602482015270151bdad95b881b9bdd08195b98589b1959607a1b6044820152606490fd5b15612a8957565b60405162461bcd60e51b815260206004820152600d60248201526c426164206d73672e76616c756560981b6044820152606490fd5b90670de0b6b3a7640000918281029281840414901517156124f957565b818102929181159184041417156124f957565b8115612af8570490565b634e487b7160e01b600052601260045260246000fd5b6040516323b872dd60e01b60208201526001600160a01b0392831660248201529290911660448301526064808301939093529181526116ff916126e2826116b6565b15612b5757565b60405162461bcd60e51b815260206004820152600d60248201526c086c2dce840e6cadcc840cae8d609b1b6044820152606490fd5b919082039182116124f957565b814710612c2f576000918291829182916001600160a01b03165af1612bbc612568565b5015612bc457565b60405162461bcd60e51b815260206004820152603a60248201527f416464726573733a20756e61626c6520746f2073656e642076616c75652c207260448201527f6563697069656e74206d617920686176652072657665727465640000000000006064820152608490fd5b60405162461bcd60e51b815260206004820152601d60248201527f416464726573733a20696e73756666696369656e742062616c616e63650000006044820152606490fd5b91909163ffffffff808094169116019182116124f957565b9594939163ffffffff60ff921687521660208601526080604086015280608086015260018060fb1b03811161032a5760609160a09160051b809183880137850101930152565b969795929491939097612ce3614139565b60005460ff60a01b1916600055600b5460ff1615612d0090612a01565b612d08612636565b60065460a81c63ffffffff1663ffffffff1610612d2490612f14565b60055496612d3c600160ff86161b808a161415612f56565b60025491612d486116f2565b918a83528760208401528860408401528460608401528b60808401528560a0840190612d76919060ff169052565b8660c08401523690612d8792612f94565b90612d919261418e565b612d9a90612fe2565b612da387614010565b95909260ff16966001881b17612db890600555565b60065460a01c60ff16612dca9061301a565b6006805460ff60a01b191660a09290921b60ff60a01b16919091179055612df58582868b8a88613969565b7ff652dd63b1aedbf9e740f3152fb67b0d94d069cf1182811ebd88921850d9356795612e43938a15612e85575b505060065460ff8160a01c1615612e5b575b50604051948594339a866130ff565b0390a46000805460ff60a01b1916600160a01b179055565b600c54612e7f91906001600160a01b0316601054916001600160a01b03169061269f565b38612e34565b60035460045460405163124e93e160e21b602082015260248101929092526044808301919091528152612f0d926000928392909190612eef90612efb90601f1990612ed16064826116d1565b6040519384916020830196637375c56f60e11b88526024840161302a565b039081018352826116d1565b51915af4612f07612568565b5061304c565b3880612e22565b15612f1b57565b60405162461bcd60e51b81526020600482015260136024820152724e6f7420706173736564206c6976656e65737360681b6044820152606490fd5b15612f5d57565b60405162461bcd60e51b815260206004820152600f60248201526e105b1c9958591e4818db185a5b5959608a1b6044820152606490fd5b9291612f9f82611721565b91612fad60405193846116d1565b829481845260208094019160051b810192831161032a57905b828210612fd35750505050565b81358152908301908301612fc6565b15612fe957565b60405162461bcd60e51b81526020600482015260096024820152682130b210283937b7b360b91b6044820152606490fd5b60ff1680156124f9576000190190565b6001600160a01b039091168152604060208201819052610a1492910190611bbc565b1561305357565b60405162461bcd60e51b815260206004820152601360248201527219195b1959d85d1958d85b1b0819985a5b1959606a1b6044820152606490fd5b90815180825260208080930193019160005b8281106130ae575050505090565b83516001600160a01b0316855293810193928101926001016130a0565b90815180825260208080930193019160005b8281106130eb575050505090565b8351855293810193928101926001016130dd565b9390610a1495936131246131409461313293885260a0602089015260a088019061308e565b9086820360408801526130cb565b9084820360608601526130cb565b9160808184039101526130cb565b1561315557565b60405162461bcd60e51b815260206004820152601760248201527f5265717565737420706173736564206c6976656e6573730000000000000000006044820152606490fd5b906116ff9463ffffffff6101e0946132729399989699855216602084015260006102008060408601528401526102208301976131e160608501825160018060a01b03169052565b60208101516001600160a01b0316608085015260408101516001600160a01b031660a08501526060810151151560c0850152608081015160e085015260a081015190610100918286015260c0810151610120908187015260e082015192610140938488015282015161016087015281015161018086015201516101a08401526101c083019060018060a01b03169052565b6001600160a01b03909216910152565b61328d6119cd612636565b6006546132a29060a81c63ffffffff166119cd565b6132b563ffffffff91828416111561314e565b6132bd6137fd565b60109081548110156135795783926132d3613740565b600c80549094906001600160a01b031681546001600160a01b0393841693916132fe919085906135d6565b600d54958054966133a1613313888654612b8c565b60065460405163579aae8f60e11b8152600481019490945263ffffffff9b8c1660248501526101206044850152600061012485018190526001600160a01b038c881681166064870152608486019190915260a485019290925260a09a909a1c8816909a1660c48301529890971660e4880152670de0b6b3a76400006101048801526020978790610144820190565b03968881600099818b895af1908161355c575b506133ca575050505050505050506116ff613683565b88849289976133e8856133e3865460018060a01b031690565b613585565b6006546001600160a01b031697845492818460a01c16948561340991612c74565b908389549061341791612b8c565b94613420611701565b6001600160a01b03909c168c528c8c018e9052166001600160a01b031660408b01528b60608b015260808a01670de0b6b3a764000090528b60a08b01521660c08901528960e089015261010088015261012087015261014086015261349960006002556000600355600060045560006005556000600655565b80546001600160a01b0316835430336134b193612b0e565b546001600160a01b03169154906134c7926135d6565b600d5460405163139c641960e31b8152948593849283916134f191309133918d906004870161319a565b03925af180156105f35761353e575b505060405163ffffffff909116815233907f15951cb2ef6993bc23a55912e7d0bcac13e4797c432aaa334816aed6914a7a909080602081015b0390a2565b8161355492903d106126935761268b81836116d1565b503880613500565b613572908a3d8c116126935761268b81836116d1565b50386133b4565b505050506116ff613683565b60405163095ea7b360e01b60208201526001600160a01b039092166024830152600060448084019190915282526080820191906001600160401b03831182841017611660576116ff926040526126fc565b604051636eb1769f60e11b81523060048201526001600160a01b03831660248201529192602083806044810103816001600160a01b0386165afa9283156105f357600093613663575b5082018092116124f95760405163095ea7b360e01b60208201526001600160a01b03909316602484015260448301919091526116ff91906126e282606481016126d4565b61367c91935060203d81116126935761268b81836116d1565b913861361f565b600c5460065460105460405163a9059cbb60e01b81526001600160a01b03928316600482015260248101919091529160209183916044918391600091165af180156105f357613722575b506136ec60006002556000600355600060045560006005556000600655565b6136f4612636565b6040519081527f0cfbbf45ab7f5225663454de7117b1b0ed5a7c133b61f54ccf367dcf8b6d4d5960203392a2565b6137399060203d81116105ec576105dd81836116d1565b50386136cd565b6040516302abf57960e61b815275536b696e6e794f7074696d69737469634f7261636c6560501b60048201526001600160a01b03906020816024817f000000000000000000000000000000000000000000000000000000000000000086165afa9081156105f3576000916137b357501690565b6137cb915060203d81116106205761061181836116d1565b1690565b9081602091031261032a5760405190602082018281106001600160401b038211176116605760405251815290565b6040516302abf57960e61b81526453746f726560d81b60048201526020906001600160a01b039082816024817f000000000000000000000000000000000000000000000000000000000000000086165afa9081156105f35783916138a5916000916138ec575b50600c54613879906001600160a01b0316610862565b604051635b97aadd60e01b81526001600160a01b03909116600482015293849283919082906024820190565b0392165afa9182156105f3576000926138bf575b50505190565b6138de9250803d106138e5575b6138d681836116d1565b8101906137cf565b38806138b9565b503d6138cc565b6139039150833d85116106205761061181836116d1565b38613863565b1561391057565b60405162461bcd60e51b8152602060048201526015602482015274149bdd5d19481b9bdd081dda1a5d195b1a5cdd1959605a1b6044820152606490fd5b919091600083820193841291129080158216911516176124f957565b94939192805195600091825b88811061398757505050505050505050565b80613a058882878a6139cb6108556139bb6139b46139a760019b8d612607565b516001600160a01b031690565b9687613fe0565b6000526008602052604060002090565b6139dd888060a01b0382161515613909565b8b836139e98685612607565b5113613a0b575b505050506139fe908c612607565b5190613ec6565b01613975565b613a6c613a1c613a79968695612607565b516040516314b231d760e21b602082019081526001600160a01b038a81166024840152958616604483015260648201929092529290931660848301528160a481015b03601f1981018352826116d1565b51908a5af4612f07612568565b613a83838a612607565b516001600160a01b0382166000908152600760205260409020613aac9086905b0191825461394d565b9055613ab8838a612607565b516001600160a01b0382166000908152600760205260409020613ae090600201918254612b8c565b905582878a388b6139f0565b6001600160a01b03811660009081526007602052604090206004908054602090613b2090610862906001600160a01b031681565b6040516318160ddd60e01b815293849182905afa9182156105f357600092613b9d575b508115613b8e57613b8481613b66610a1495613b61613b8995613bbd565b613c47565b6003613b7b600283015460018401549061394d565b910154906129e8565b612abe565b612aee565b505050670de0b6b3a764000090565b613bb691925060203d81116126935761268b81836116d1565b9038613b43565b6003810190815463ffffffff9081835460a81c16613bd9612636565b9081039081116124f957613c01670de0b6b3a764000091613bfc600e5485612adb565b612adb565b0481811015613c40575b81039081116124f9576116ff9355613c21612636565b825463ffffffff60a81b1916911660a81b63ffffffff60a81b16179055565b5080613c0b565b6040516370a0823160e01b81523060048201526001600160a01b038216602082602481845afa9182156105f357600092613d44575b50600c54613c9490610862906001600160a01b031681565b1480613d33575b15613d2d57601054613cac91612b8c565b905b6001600160a01b0381166000908152600760205260409020600201548211613cd4575050565b613d2981613d026002613cfa819560018060a01b03166000526007602052604060002090565b015485612b8c565b6001600160a01b03821660009081526007602052604090206111a3906001019182546129e8565b0155565b90613cae565b5060ff60065460a01c161515613c9b565b613d5d91925060203d81116126935761268b81836116d1565b9038613c7c565b613d6d81613c47565b60018060a01b038091166000526007602052613dfa604060002091613dc563ffffffff60405192613d9d8461169b565b8554908116845260ff8160a01c161515602085015260a81c16604083019063ffffffff169052565b60018301549081606082015260a0600360028601549586608085015201549101526000808213600014613e1a5750809261298f565b8015613e0c57613b89610a1492612abe565b5050670de0b6b3a764000090565b9050809261298f565b90613dfa90613e3183613c47565b60018060a01b038093166000526007602052613ebf604060002093613e8963ffffffff60405192613e618461169b565b8754908116845260ff8160a01c161515602085015260a81c16604083019063ffffffff169052565b60018501549081606082015260a060036002880154976080840198895201549101526000808213600014613e1a5750809261298f565b925161298f565b670de0b6b3a7640000613edb600f5484612adb565b0491828103908082116124f9578303613f1f575b5081613ef9575050565b6001600160a01b03166000908152600a6020526040902080549182019182106124f95755565b6001600160a01b03821660009081526007602052604090206003018054908282018092116124f957556001600160a01b0382166000908152600760205260409020613f6c90600190613aa3565b905538613eef565b906135397f218987b934c2f6bc596136829fbf43a5fef4d6fafce41f3f6254d9a870c2deec91613fcc600080613fa987614010565b604051612efb81613a5e896020830195637375c56f60e11b87526024840161302a565b604051918291602083526020830190611bbc565b604080516001600160a01b03909216602083019081529082019290925261400a8160608101613a5e565b51902090565b600052600960205260406000209060018060a01b036001818454169301541690811561408457823b1561403f57565b60405162461bcd60e51b815260206004820152601760248201527f41646170746572206e6f7420696e697469616c697a65640000000000000000006044820152606490fd5b60405162461bcd60e51b815260206004820152601960248201527f53706f6b65506f6f6c206e6f7420696e697469616c697a6564000000000000006044820152606490fd5b60ff60005460a01c166140d857565b7f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316803b1561032a57600060049160405192838092630d0e30db60e41b825234905af180156105f3576141305750565b6116ff9061164d565b60ff60005460a01c161561414957565b60405162461bcd60e51b815260206004820152601f60248201527f5265656e7472616e637947756172643a207265656e7472616e742063616c6c006044820152606490fd5b610a14929160405161422581613a5e602082019460208652805160408401526141c7602082015160e060608601526101208501906130cb565b60c06141fc6141e8604085015193603f1994858983030160808a01526130cb565b6060850151848883030160a08901526130cb565b9260808101518287015260ff60a08201511660e08701520151908483030161010085015261308e565b51902091929091906000915b845183101561427e576142448386612607565b519060008282101561426c575060005260205261426660406000205b926124ea565b91614231565b60409161426693825260205220614260565b91509250149056fea26469706673582212201379f8122082db0003c3b270a3169c18b078173e961e9b066732ab47d4a3c82364736f6c63430008120033";
const isSuperArgs = (xs) => xs.length > 1;
class HubPool__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_lpTokenFactory, _finder, _weth, _timer, overrides) {
        return super.deploy(_lpTokenFactory, _finder, _weth, _timer, overrides || {});
    }
    getDeployTransaction(_lpTokenFactory, _finder, _weth, _timer, overrides) {
        return super.getDeployTransaction(_lpTokenFactory, _finder, _weth, _timer, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.HubPool__factory = HubPool__factory;
HubPool__factory.bytecode = _bytecode;
HubPool__factory.abi = _abi;
